module.exports = __webpack_public_path__ + "img/volt.edef2bce.svg";